import * as R from 'ramda';
import FileSaver from 'file-saver';
import getAccessToken from 'selectors/getAccessToken';

const downloadCSV = (fetchFn: Function, query, fileName: string = 'GSI CSV Export') => (
  async (_, getState) => {
    const state = getState();
    const auth = getAccessToken(state);

    const resp = await fetchFn({
      auth,
      query: R.pipe(
        R.assoc('output', 'csv'),
        R.assoc('limit', -1),
      )(query),
      responseType: 'blob',
    });

    if (resp.data) {
      const blob = new Blob([resp.data], { type: 'text/csv' });
      FileSaver.saveAs(blob, `${fileName}.csv`);
    }

    return resp;
  }
);

export default downloadCSV;
